import React from 'react'
import IconButton from '@mui/material/IconButton'
import MenuIcon from '@mui/icons-material/Menu'
import Box from '@mui/material/Box'

import { getAssetURL } from 'lib/utility/GetAssetUrl'
import { customStyles } from 'components/Sidebar/Styled/CustomStyles'

type DrawerHeaderProps = {
  collapsedWidth: string
  isDrawerVisible: boolean
  handleDrawer: () => void
}

const DrawerHeader = ({ handleDrawer, isDrawerVisible }: DrawerHeaderProps) => {
  return (
    <Box sx={customStyles.headerWrapper}>
      <Box sx={customStyles.logoWrapper}>
        {isDrawerVisible ? (
          <img
            src={getAssetURL('/sidebar/engagement_logo.svg')}
            alt="EngagementHQ"
            style={customStyles.logoStyles}
          />
        ) : (
          <img
            src={getAssetURL('/sidebar/engagement_logo_icon_only.svg')}
            style={customStyles.logoStyles}
            alt="EngagementHQ"
          />
        )}
      </Box>
      <Box>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={handleDrawer}
          edge="start"
          sx={customStyles.hamburgerButton}
        >
          <MenuIcon />
        </IconButton>
      </Box>
    </Box>
  )
}

export default DrawerHeader
